import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { tap, switchMap } from 'rxjs/operators'
import {
  EXP_NEXTGEN_ATHLETE_PROFILE_ID,
  EXP_NEXTGEN_ATHLETE_PROFILE_VARIATION
} from 'src/app/shared/experimentation/experiment.model'
import { ExperimentationService } from 'src/app/shared/experimentation/experimentation.service'

@Injectable({
  providedIn: 'root'
})
export class NextGenAthleteProfileGuard implements CanActivate {
  constructor(private router: Router, private experimentService: ExperimentationService) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.experimentService
      .isInVariation(EXP_NEXTGEN_ATHLETE_PROFILE_ID, EXP_NEXTGEN_ATHLETE_PROFILE_VARIATION, false)
      .pipe(
        switchMap(isInExperiment => {
          if (!isInExperiment) {
            return of(true) // Allow navigation to the legacy athlete profile with no side effect (redirecting)
          }

          const currentUrl = state.url

          // Detect both standard and extended slug formats, capture the athlete ID - allow child routes & query params
          const slugMatch = currentUrl.match(/^\/people\/(\d+)(?:-[a-zA-Z-]+)?(\/[a-zA-Z-]+)?(\?.*)?$/)

          if (slugMatch) {
            const athleteId = slugMatch[1]

            // Redirect to nextgen and prevent original navigation
            return of(false).pipe(
              tap(() => {
                window.location.href = `/nextgen/people/${athleteId}` // 301 Redirect to top level since tabs are not 1:1 between NG and legacy
              })
            )
          }

          // Allow legacy navigation if no slug match
          return of(true)
        })
      )
  }
}
